/**
 * TODO: This need refactoring and rationalised. Changes throughout
 * TODO: development lead to 3 versions of this which should be combined
 * TODO: into a single component
 * @see IngredientForm,
 * @see IngredientProductForm
 * @see LinkIngredientsToProductModal
 */

import { Box, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useActionRunner } from '../../../../../notification'
import { Typography } from '../../../../../ui'
import { useRecipes } from '../../hooks'
import IngredientProductList from '../IngredientProductsList'
import SearchSelect from '../../../../../ui/components/SearchSelect'

const IngredientProductForm = React.forwardRef(
  ({ suppliers, isFetchingSuppliers, onSelectProduct }, ref) => {
    const [selectedSupplier, setSelectedSupplier] = React.useState(null)
    const [selectedProduct, setSelectedProduct] = React.useState(null)

    const { fetchAgreementProducts, agreementProducts } = useRecipes()

    const [fetchProducts, isFetchingProducts] = useActionRunner(
      fetchAgreementProducts
    )

    useEffect(() => {
      if (selectedSupplier && selectedSupplier.id)
        fetchProducts(selectedSupplier.id)
    }, [selectedSupplier])

    const handleSupplierChange = (e, newValue) => {
      const supplierId = newValue ? newValue.value : null
      setSelectedSupplier(suppliers.find(s => s.id === supplierId))
    }

    const handleProductSelection = (e, newValue) => {
      const productId = newValue ? newValue.value : null
      const product = agreementProducts.find(p => p.id === productId)
      setSelectedProduct(product)
      onSelectProduct({ supplier: selectedSupplier, product })
    }

    const mapToOption = ({ id, name }) => ({ value: id, label: name })

    const reset = () => {
      setSelectedSupplier(null)
      setSelectedProduct(null)
    }

    React.useImperativeHandle(ref, () => ({
      reset,
    }))

    const mapToProductOption = ({ id, product }) => ({
      value: id,
      label: `${product.name} (£${product.price})`,
    })

    return (
      <Grid container spacing={0}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            {!isFetchingSuppliers ? (
              <SearchSelect
                fullWidth
                label="Select Supplier"
                margin="normal"
                name="supplierId"
                onChange={handleSupplierChange}
                options={[...suppliers.map(mapToOption)]}
              />
            ) : (
              <Skeleton
                variant="rect"
                height={55}
                style={{
                  borderRadius: 10,
                  marginTop: 10,
                  marginBottom: 9,
                }}
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {!isEmpty(selectedSupplier) && !isFetchingProducts ? (
              <>
                {selectedSupplier !== null &&
                agreementProducts &&
                agreementProducts.length > 0 ? (
                  <SearchSelect
                    fullWidth
                    label="Select Product"
                    margin="normal"
                    name="environmentId"
                    onChange={handleProductSelection}
                    options={[...agreementProducts.map(mapToProductOption)]}
                  />
                ) : (
                  <Typography
                    variant="body2"
                    align="center"
                    style={{ marginTop: '1.5rem' }}
                  >
                    No supplier products available to this environment
                  </Typography>
                )}
              </>
            ) : null}
            {isFetchingProducts ? (
              <Skeleton
                variant="rect"
                height={55}
                style={{
                  borderRadius: 10,
                  marginTop: 10,
                  marginBottom: 9,
                }}
              />
            ) : null}
          </Grid>
          <Grid item xs={12}>
            {selectedProduct ? (
              <Box bgcolor="background.paper" borderRadius={10} p={2}>
                <Grid container spacing={2}>
                  <IngredientProductList
                    products={[selectedProduct]}
                    supplier={selectedSupplier}
                  />
                </Grid>
              </Box>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    )
  }
)

export default IngredientProductForm
